import { SsnFieldInfo } from '@app/queryTyping';

/**
 * Determines field length based on 'dataPattern' property
 */
export const fieldLengthWithoutHypen = (dataPattern: SsnFieldInfo['dataPattern']) => (
  dataPattern != null ? dataPattern.replace(/-/g, '').length : 9
);

/**
 * Make pattern length equal to mask length
 * @example
 * normilizePatternLength('0000', '***-**-0000') // => '***-**-0000'
 * normilizePatternLength('00', '**00') // => '**00'
 * normilizePatternLength('000-00-0000', '***-**-0000') // => '000-00-0000'
 */
export const normilizePatternLength = (pattern: string, mask: string) => (
  `${mask.slice(0, -pattern.length)}${pattern}`
);
